import React from 'react';

type BadgeVariant = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'purple';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
}

const variants: Record<BadgeVariant, React.CSSProperties> = {
  success: { background: '#D1FAE5', color: '#065F46' },
  warning: { background: '#FEF3C7', color: '#92400E' },
  error: { background: '#FEE2E2', color: '#991B1B' },
  info: { background: '#DBEAFE', color: '#1D4ED8' },
  neutral: { background: '#F3F4F6', color: '#4B5563' },
  purple: { background: '#EDE9FE', color: '#7C3AED' },
};

export const Badge: React.FC<BadgeProps> = ({ variant = 'neutral', children }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '4px',
      padding: '2px 8px',
      borderRadius: '10px',
      fontSize: '11px',
      fontWeight: 600,
      ...variants[variant],
    }}
  >
    {children}
  </span>
);
